/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Test_Print_ErrorInputs */

const vi_print_admin_test_print_error = /** @type {(inputs: Print_Admin_Test_Print_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi lệnh in thử thất bại`)
};

/**

* @param {Print_Admin_Test_Print_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_test_print_error = /** @type {((inputs?: Print_Admin_Test_Print_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Test_Print_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_test_print_error(inputs)
});